export const MASKED_PHONE_DEFINITION = 'phone';
export const MASKED_POSTAL_DEFINITION = 'postal';
export const TESTING_PARAM_CC_URL = 'auto_testing_cc';

export const INVALID_PHONE_MSG_DATA_ATTR = 'data-msg-maskphonenumber';
export const INVALID_POSTAL_MSG_DATA_ATTR = 'data-msg-maskpostalnumber';

export const MASKED_PHONE_FIELD_ID = '#phone';
export const MASKED_POSTAL_FIELD_ID = '#txtZip';
export const MASKED_VAT_FIELD_ID = '#txtVatId';
export const HIDDEN_PHONE_FIELD_ID = 'hiddenPhone';
export const HELPER_PHONE_LABEL_CLASS = '.phone-format';
export const HELPER_POSTAL_LABEL_CLASS = '.postal-format';
export const HELPER_VAT_LABEL_CLASS = '.vat-format';
export const INVALID_PHONE_NUMBER_MSG = 'MASK_INVALID';
export const INVALID_POSTAL_NUMBER_MSG = 'MASK_POSTAL_INVALID';

export const PRODUCT_REGISTRATION_PAGE = 'PRODUCT_REGISTRATION';
export const PRODUCT_REGISTRATION_COUNTRY_FILED_ATTR = 'data-answer-code';
export const PRODUCT_REGISTRATION_PHONE_FIELD_CLASS = '.phone';
export const PRODUCT_REGISTRATION_HELPER_LABEL_CLASS = '.phone-helper';
export const PRODUCT_REGISTRATION_POSTAL_FIELD_CLASS = '.postal';
export const PRODUCT_REGISTRATION_HELPER_POSTAL_LABEL_CLASS = '.postal-helper';
export const COMMON_PAGE = 'COMMON';
export const VIEW_MODE = 'VIEW';
export const VIEW_MODE_ADDRESS_FIELD_SELECTOR = '.address';
export const VIEW_MODE_COUNTRY_CODE_FIELD_SELECTOR = '.country-code';
export const VIEW_MODE_PHONE_FIELD_SELECTOR = '.phone-view';
export const VIEW_MODE_POSTAL_FIELD_SELECTOR = '.postal-view';

export const PHONE_CONFIG = 'validationPhoneCfg';
export const POSTAL_CONFIG = 'validationPostalCfg';

export const COUNTRY_NOT_RECOGNIZED = 'NOT_RECOGNIZED';
